// スライダーの色定義
export enum SliderColor {
  BLUE = 'blue',
  GREEN = 'green',
  RED = 'red',
  PURPLE = 'purple',
  ORANGE = 'orange',
}

// 色ごとのCSSカスタムプロパティ設定
export class SliderColorConfig {
  private static readonly colorMap: Record<
    SliderColor,
    {
      track: string
      range: string
      thumb: string
    }
  > = {
    [SliderColor.BLUE]: {
      track: 'rgba(59, 130, 246, 0.3)',
      range: 'rgba(59, 130, 246, 0.8)',
      thumb: 'rgb(59, 130, 246)',
    },
    [SliderColor.GREEN]: {
      track: 'rgba(34, 197, 94, 0.3)',
      range: 'rgba(34, 197, 94, 0.8)',
      thumb: 'rgb(34, 197, 94)',
    },
    [SliderColor.RED]: {
      track: 'rgba(239, 68, 68, 0.3)',
      range: 'rgba(239, 68, 68, 0.8)',
      thumb: 'rgb(239, 68, 68)',
    },
    [SliderColor.PURPLE]: {
      track: 'rgba(168, 85, 247, 0.3)',
      range: 'rgba(168, 85, 247, 0.8)',
      thumb: 'rgb(168, 85, 247)',
    },
    [SliderColor.ORANGE]: {
      track: 'rgba(249, 115, 22, 0.3)',
      range: 'rgba(249, 115, 22, 0.8)',
      thumb: 'rgb(249, 115, 22)',
    },
  }

  /**
   * 指定された色のスタイルオブジェクトを取得
   * CSSカスタムプロパティとして設定可能
   */
  static getStyles(color: SliderColor): React.CSSProperties {
    const colors = this.colorMap[color] || this.colorMap[SliderColor.BLUE]
    return {
      '--slider-track-color': colors.track,
      '--slider-range-color': colors.range,
      '--slider-thumb-border-color': colors.thumb,
    } as React.CSSProperties
  }

  /**
   * 利用可能な色の一覧を取得
   */
  static getAvailableColors(): SliderColor[] {
    return Object.values(SliderColor)
  }
}
